<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <v-icon color="red" class="mr-2">mdi-alert-circle-outline</v-icon>
        {{ title }}
      </v-card-title>

      <v-card-text>
        <v-textarea
          autofocus
          v-model="errorComment"
          outlined
          rows="4"
          placeholder="Virhe"
          :hint="hint"
          persistent-hint
          v-prevent-keys
        ></v-textarea>

        <v-expansion-panels class="mt-3">
          <v-expansion-panel color="info">
            <v-expansion-panel-header class="py-2">
              <div class="d-flex align-center">
                <v-icon color="info">mdi-information-outline</v-icon>
                <div class="text-caption font-weight-medium ml-2">
                  Miten käsittelemme palautteet?
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="text-caption">
                1. Virheilmoitukset lähetetään suoraan kehitystiimille sähköpostitse<br>
                2. Korjaamme virheet mahdollisimman nopeasti<br>
                3. Lähetämme sinulle sähköpostin, kun virhe on korjattu
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey darken-1"
          text
          @click="$emit('input', false)"
        >
          Peruuta
        </v-btn>
        <v-btn
          color="primary"
          @click="submitReport"
        >
          Lähetä
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import a from '@/utils/axios/axios'
import { mapActions } from 'vuex'

export default {
  name: 'ErrorReportDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Ilmoita virheestä'
    },
    run_id: {
      type: Number,
      default: null
    },
    event_id: {
      type: String,
      default: null,
    },
    game_id: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: 'Kerro virheestä. Jos virhe on kohtalaisen selvä, voit jättää kommentin tyhjäksi.'
    },
    type: {
      type: String,
      default: 'event'
    }
  },
  data: () => ({
    errorComment: '',
  }),
  methods: {
    ...mapActions('noti', ['success', 'error']),
    async submitReport() {
      try {
        const feedbackData = {
          type: this.type ||'event',
          game_id: this.game_id,
          event_id: this.event_id,
          run_id: this.run_id,
          feedback: this.errorComment
        };

        await a.post('/feedback', feedbackData)
          .then(() => {
            this.$emit('input', false);
            this.errorComment = '';
            this.success('Kiitos ilmoituksesta! Korjaamme ongelman.');
            this.$emit('input', false);
            this.errorComment = '';
          })
          .catch((error) => {
            console.error('Error submitting feedback:', error);
            this.error('Virheilmoituksen lähetys epäonnistui. Yritä uudelleen myöhemmin.');
          })
      } catch (error) {
        console.error('Error submitting feedback:', error);
        this.error('Virheilmoituksen lähetys epäonnistui. Yritä uudelleen myöhemmin.');
      }
    }
  }
}
</script>

<style scoped>
.v-card-title {
  display: flex;
  align-items: center;
}
</style>